import type { DomainEvent } from "@/stores/useDomainEventStore";

/**
 * Stable coalesce key for {@link useDomainEventInvalidation} debouncing.
 * Entity-bearing payloads keep distinct keys so rapid multi-entity updates
 * (e.g. two assumption.changed in one agent turn) are not dropped.
 * Events without an entity id collapse by event type.
 */
export function domainEventInvalidateKey(event: DomainEvent): string {
  const payload = event.payload;
  if (typeof payload?.assumptionId === "string" && payload.assumptionId) {
    return `assumption:${payload.assumptionId}`;
  }
  if (typeof payload?.hypothesisId === "string" && payload.hypothesisId) {
    return `hypothesis:${payload.hypothesisId}`;
  }
  if (typeof payload?.experimentId === "string" && payload.experimentId) {
    return `experiment:${payload.experimentId}`;
  }
  if (typeof payload?.documentId === "string" && payload.documentId) {
    return `document:${payload.documentId}`;
  }
  if (typeof payload?.edgeId === "string" && payload.edgeId) {
    return `edge:${payload.edgeId}`;
  }
  if (typeof payload?.batchId === "string" && payload.batchId) {
    return `batch:${payload.batchId}`;
  }
  if (typeof payload?.messageId === "string" && payload.messageId) {
    return `message:${payload.messageId}`;
  }
  if (
    typeof payload?.subjectPublicId === "string" &&
    payload.subjectPublicId
  ) {
    return `subject:${payload.subjectType ?? "*"}:${payload.subjectPublicId}`;
  }
  return `type:${event.eventType}`;
}
